import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_1c1f0101f224e2c4294be2ca2bb3f3de/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.3_db0@0.3.2_es_1c1f0101f224e2c4294be2ca2bb3f3de/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  guest: () => import("/opt/buildhome/repo/middleware/guest.ts")
}